import { render, staticRenderFns } from "./RegisterCanceled.vue?vue&type=template&id=fc0dbefa&scoped=true&"
import script from "./RegisterCanceled.vue?vue&type=script&lang=js&"
export * from "./RegisterCanceled.vue?vue&type=script&lang=js&"
import style0 from "./RegisterCanceled.vue?vue&type=style&index=0&id=fc0dbefa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc0dbefa",
  null
  
)

export default component.exports